import { API } from "./api";
import { devWarn } from "./log";

// Stream a chat completion. Calls onDelta(token) as tokens arrive.
// attachments: [{ name, mime, data }] where data is base64 (no data: prefix).
export async function streamChat(sessionId, message, onDelta, attachments = []) {
  const res = await fetch(`${API}/ai/chat`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ session_id: sessionId, message, attachments }),
  });
  if (!res.ok || !res.body) throw new Error("AI request failed");

  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buf = "";
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += decoder.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    for (const p of parts) {
      const line = p.trim();
      if (!line.startsWith("data:")) continue;
      const data = line.slice(5).trim();
      if (data === "[DONE]") return;
      try {
        const j = JSON.parse(data);
        if (j.error) throw new Error(j.error);
        if (j.delta) onDelta(j.delta);
      } catch (err) {
        if (err instanceof SyntaxError) {
          devWarn("Skipping unparseable SSE chunk:", data);
        } else {
          throw err; // surface server-reported AI errors to the caller
        }
      }
    }
  }
}
